// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportingDetailsGoalsPage_wrapper__dCZ7W"};